import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { User } from './domain/user';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  private url = environment.serverUrl + '/user';
  private urlInspector = this.url + '/inspector';

  constructor(
    private http: HttpClient
  ) { }

  getInspectors(): Observable<User[]> {
    return this.http.get<User[]>(this.urlInspector);
  }
}
